module.exports = "<app-pre-login-form [submitText]=\"'Confirm'\" [fields]=\"fields\" (formSubmitted)=\"onSubmit($event)\">\r\n</app-pre-login-form>"